import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ConnectedNetworkDemographics } from '../NetworkDemographics';
import { ConnectedNetworkListeners } from '../NetworkListeners';
import { ConnectedNetworkFollowers } from '../NetworkFollowers';
import { ConnectedNetworkStartsStreamsContainer } from '../NetworkStartsStreamsContainer';
import { ConnectedDateRangeSelector } from '../../../components/Shared/DateRangeSelector';
import { requestCsv } from '../../../store/downloadCsv';
import { selectNetworkMetadata } from '../../../store/selectors';
import { Helmet } from 'react-helmet';
import { NetworkMetadata, ReduxState } from '../../../types';

type Props = {
  networkId: string;
  networkMetadata?: NetworkMetadata;
  requestCsv: typeof requestCsv;
};

export class NetworkAudience extends PureComponent<Props> {
  render() {
    return (
      <Fragment>
        <Helmet
          title={`Audience ${
            /* istanbul ignore next*/ this.props.networkMetadata
              ? ` - ${this.props.networkMetadata.name}`
              : ''
          }`}
        />
        <ConnectedDateRangeSelector
          downloadDataAsCsv={
            /* istanbul ignore next */ () => {
              this.props.requestCsv('network', [
                'starts',
                'streams',
                'listeners',
                'followers',
                'age',
                'gender',
                'countries',
              ]);
            }
          }
        />
        <ConnectedNetworkStartsStreamsContainer
          data-qa="network-starts-streams"
          networkId={this.props.networkId}
        />
        <ConnectedNetworkListeners data-qa="network-listeners" networkId={this.props.networkId} />
        <ConnectedNetworkFollowers data-qa="network-followers" networkId={this.props.networkId} />
        <ConnectedNetworkDemographics
          data-qa="network-demographics"
          networkId={this.props.networkId}
        />
      </Fragment>
    );
  }
}

const selectors = createStructuredSelector<
  ReduxState,
  {
    networkMetadata: ReturnType<typeof selectNetworkMetadata>;
  }
>({
  networkMetadata: selectNetworkMetadata,
});

const actions = {
  requestCsv,
};

export const ConnectedNetworkAudience = connect(selectors, actions)(NetworkAudience);
